import * as echarts from 'echarts/dist/echarts.js';
import "leaflet/dist/leaflet.css";
import Template from '../../Template'
import { DeviceUsage, HeaderComp, Spiner, } from '../../components'
import { OverviewChart, OverviewSource, OverviewVisitors, Widgets } from '../../services'
import { GET_DEVICE, GET_INCOMING, GET_LOCATIONS, GET_SOURCE, GET_STATUS } from '../../Graphql/queries/getQueries';
import { useQuery } from '@apollo/client';


const Overview = () => {
    const { loading, data } = useQuery(GET_STATUS, { variables: { page: 1 } })
    const { loading: incomingLoading, data: incomingData } = useQuery(GET_INCOMING)
    const { data: deviceData } = useQuery(GET_DEVICE)
    const { loading: sourceLoading, data: sourceData } = useQuery(GET_SOURCE)
    const OverviewPieChartData = data?.Status?.nodes.filter((item) => item.total > 0).map((item) => {
        return {
            value: item.total,
            name: item.text,
            itemStyle: { color: item.color, emphasis: { shadowBlur: 25, shadowColor: item.color } }
        }
    })
    const OverviewChartData = (value) => incomingData?.Dashboard?.incoming.map((item) => item[value]).reverse()
    const totalDevice = deviceData?.Dashboard?.device?.reduce((acc, item) => item.value + acc, 0)
    const totalIncoming = incomingData?.Dashboard?.incoming?.reduce((acc, item) => item.value + acc, 0)
    const totalUnprocessed = data?.Status?.nodes?.filter((item) => item.text === 'Unprocessed')[0]?.total
    const OverviewDeviceData = deviceData?.Dashboard?.device.map((item) => ({ name: item.name, className: item.name.toLocaleLowerCase(), value: item.value, width: item.value * 100 / totalDevice }))
    const OverviewSourceData = sourceData?.Dashboard?.source.map((item) => ({ value: item.value, name: item.name }))

    // console.log('locationsData');

    const overviewOption = {
        baseOption: {
            legend: {
                orient: 'vertical',
                right: '30%',
                top: '30%',
                icon: 'circle',
                selected: 'false'
            },

            series: [

                {
                    name: 'Overview',
                    type: 'pie',
                    radius: [60, 90],
                    center: ['30%', '50%'],
                    // roseType: 'area',
                    itemStyle: {
                        borderRadius: 0
                    },
                    label: {
                        show: false
                    },
                    emphasis: {
                        label: {
                            show: true
                        }
                    },
                    data: OverviewPieChartData
                }
            ]
        },
        media: [
            {
                query: {
                    maxWidth: 600
                },
                option: {
                    legend: {
                        // right: 'left',
                        left: 0,
                        bottom: '10%',
                        orient: 'horizontal'
                    },
                    series: [
                        {
                            radius: [40, '50%'],
                            center: ['50%', '30%']
                        },

                    ]
                }
            },
        ]


    };
    const incomingOption = {
        maxWidth: '100%',
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                // label: {
                //     backgroundColor: '#6a7985'
                // }
            }
        },

        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: OverviewChartData('name')
        },
        yAxis: [
            {
                type: 'value'
            }
        ],
        series: [
            {
                lineStyle: { color: 'transparent' },
                name: 'Chart',
                type: 'line',
                stack: 'Total',
                areaStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0.8, color: '#E0ECFE' // color at 0% position
                    }, {
                        offset: 1, color: '#E0ECFE00' // color at 100% position
                    }], false)
                },
                emphasis: {
                    focus: 'series',
                    areaStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0.8, color: '#E0ECFE' // color at 0% position
                        }, {
                            offset: 1, color: '#E0ECFE00' // color at 100% position
                        }], false)
                    },
                },
                data: OverviewChartData('value')
            },
        ]
    };

    const sourceOption = {
        baseOption: {
            series: [

                {
                    name: 'Source Info',
                    type: 'pie',
                    radius: [50, 150],
                    // center: ['75%', '50%'],
                    roseType: 'area',
                    itemStyle: {
                        borderRadius: 0
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    label: {
                        // alignTo: 'edge',
                        formatter: '{name|{b}}\n {time|{c}}',
                        // minMargin: 9,
                        edgeDistance: 0,
                        // lineHeight: 17,
                        rich: {
                            time: {
                                fontSize: 10,
                                color: '#999'
                            }
                        }
                    },
                    labelLine: {
                        length: 5,
                        length2: 10,
                        maxSurfaceAngle: 10
                    },

                    data: OverviewSourceData
                }
            ]
        },
        media: [
            {
                query: {
                    maxWidth: 600,
                },
                option: {
                    series: [{
                        radius: [40, 100],
                    }]
                }
            }
        ]


    };
    const AvrDaysOption = {
        tooltip: {
            formatter: '{a} <br/>{b} : {c} day'
        },
        series: [
            {
                name: 'Average Response Time',
                type: 'gauge',
                radius: '100%',
                splitLine: {
                    length: 13,
                    lineStyle: {
                        width: 4,
                        color: '#1A99CA'
                    }
                }, axisLabel: {
                    distance: 20,
                    color: 'black',
                    fontSize: 17
                },
                axisTick: {
                    length: 0,

                },
                title: {
                    show: true, offsetCenter: [0, '70%']
                },
                detail: {
                    valueAnimation: true,
                    formatter: '{value}'
                },
                data: [
                    {
                        value: 50,
                        name: 'Days'
                    }
                ], max: 250,
                itemStyle: {
                    color: '#1A99CA',
                    shadowColor: 'rgba(0,138,255,0.45)',
                    shadowBlur: 10,
                    shadowOffsetX: 2,
                    shadowOffsetY: 2
                },
                progress: {
                    show: true,
                    roundCap: true,
                    width: 10
                },
                pointer: {
                    icon: 'path://M2090.36389,615.30999 L2090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.56078 C2090.53845,735.564269 2090.45117,735.566014 2090.36389,735.566014 L2090.36389,735.566014 C2086.74736,735.566014 2083.81557,732.63423 2083.81557,729.017692 C2083.81557,728.930412 2083.81732,728.84314 2083.82081,728.755929 L2088.2792,617.312956 C2088.32396,616.194028 2089.24407,615.30999 2090.36389,615.30999 Z',
                    length: '75%',
                    width: 13,
                    offsetCenter: [0, '5%']
                }
            }
        ]
    };

    // if (loading) return <Spiner />
    return (
        <Template
            headerTitle={['Overview']}
            hasFilters={true}
        >

            {/* ::::::::::Card Widgets::::::::::: */}
            <Widgets totalIncoming={totalIncoming} totalUnprocessed={totalUnprocessed} loading={loading} />

            {/* ::::::::::Overview Pie Chart::::::::::: */}
            <OverviewChart option={overviewOption} title="Overview" loading={loading} />

            {/* ::::::::::Overview Incoming Chart::::::::::: */}
            <OverviewChart option={incomingOption} title="Incoming" loading={incomingLoading} />

            {/* ::::::::::Device Percentage::::::::::: */}
            <div className="item_comp" >
                <HeaderComp title="Device" />
                {OverviewDeviceData?.map(({ name, width, className, value }, i) => (<DeviceUsage key={i} name={name} width={width} className={className} count={value} />))}
            </div>

            {/* :::::::::: Source & Average Response Time::::::::::: */}
            <OverviewSource source={sourceOption} avaregDays={AvrDaysOption} sourceLoading={sourceLoading} />

            {/* :::::::::: Visitors world map::::::::::: */}
            <OverviewVisitors />


        </Template>
    )
}

export default Overview